import planIcon from "../images/treatment_plan_icon.svg";
import groupsIcon from "../images/treatment_groups_icon.svg";
import practiceIcon from "../images/treatment_practice_icon.svg";
import docsIcon from "../images/treatment_docs_icon.svg";
import calendarIcon from "../images/treatment_calendar_icon.svg";
import goalsCalendarIcon from "../images/goals_calendar.svg";
import prescriptionsIcon from "../images/treatment_prescriptions_icon.svg";
import callIcon from "../images/getHelp_call.svg";
import chatIcon from "../images/getHelp_chat.svg";
import forumIcon from "../images/getHelp_forum.svg";
import videoIcon from "../images/getHelp_video.svg";
import powerIcon from "../images/goals_power.svg";
import progressIcon from "../images/goals_progress.svg";
import reportsIcon from "../images/goals_reports.svg";
import questionnairesIcon from "../images/reports_icon.svg";
import settingsIcon from "../images/profile_settings.svg";
import accountIcon from "../images/profile_account.svg";
import cardIcon from "../images/profile_card.svg";
import invoiceIcon from "../images/profile_invoice.svg";
import { IHomePageContentsSection, SubCategories } from "../types/types";
import { tWithKeyAttr as t } from "../i18nHelper";

export const treatmentSections: IHomePageContentsSection[] = [
  {
    value: SubCategories.Treatment,
    icon: planIcon,
    text: "TREATMENT_PLAN",
    navigateTo: "/treatment",
    state: {},
  },
  {
    value: SubCategories.SupportGroup,
    icon: groupsIcon,
    text: "SUPPORT_GROUP",
    navigateTo: "/treatment",
    state: {},
    disabled: true
  },
  {
    value: SubCategories.Practice,
    icon: practiceIcon,
    text: "EXERCISES_2",
    navigateTo: "/treatment",
    state: {},
    disabled: false
  },
  {
    value: SubCategories.Docs,
    icon: docsIcon,
    text: "DOCUMENTS_2",
    navigateTo: "/treatment",
    state: {}
  },
  {
    value: SubCategories.Calendar,
    icon: calendarIcon,
    text:  "APPOINTMENT_JOURNAL",
    navigateTo: "/treatment",
    state: {},
  },
  {
    value: SubCategories.Questionnaires,
    icon: questionnairesIcon,
    text: "MY_QUESTIONNAIRES",
    navigateTo: "/treatment",
    state: {},
  },
  {
    value: SubCategories.Prescriptions,
    icon: prescriptionsIcon,
    text: "PRESCRIPTIONS_2",
    navigateTo: "/treatment",
    state: {},
    disabled: true
  },
];

export const profileSections: IHomePageContentsSection[] = [
  {
    value: SubCategories.Account,
    icon: accountIcon,
    text: "ACCOUNT_DETAILS_2",
    navigateTo: "/profile",
    state: {},
  },
  {
    value: SubCategories.Card,
    icon: cardIcon,
    text: "UPDATE_CREDIT_CARD_2",
    navigateTo: "/profile",
    state: {},
  },
  {
    value: SubCategories.Invoices,
    icon: invoiceIcon,
    text: "INVOICES_PAYMENTS_2",
    navigateTo: "/profile",
    state: {},
    disabled: true

  },
  {
    value: SubCategories.Settings,
    icon: settingsIcon,
    text: "SETTINGS_2",
    navigateTo: "/profile",
    state: {},
  },
];

export const helpSections: IHomePageContentsSection[] = [
  {
    value: SubCategories.Coupon,
    icon: callIcon,
    text: "IN_PHONE",
    navigateTo: "/prevencher",
    state: { pathname: "chatGetHelp-phone" },
  },
  {
    value: SubCategories.Coupon,
    icon: videoIcon,
    text: "IN_VIDEO",
    navigateTo: "/prevencher",
    state: { pathname: "chatGetHelp-video" },
  },
  {
    value: SubCategories.Coupon,
    icon: chatIcon,
    text: "IN_CHAT",
    navigateTo: "/prevencher",
    state: { pathname: "chatGetHelp-chat" },
  },
  {
    value: SubCategories.Coupon,
    icon: forumIcon,
    text: "IN_FORUM",
    navigateTo: "/forum",
    state: {},
    disabled: false
  },
];
export const goalsSections: IHomePageContentsSection[] = [
  {
    value: SubCategories.Achieved,
    icon: goalsCalendarIcon,
    text: "WHAT_I_DID_THIS_MONTH_2",
    navigateTo: "/goals",
    disabled: true,
    state: {},
  },
  {
    value: SubCategories.Progress,
    icon: progressIcon,
    text: "MY_GOALS_PROGRESS_2",
    navigateTo: "/goals",
    state: {},
  },
  {
    value: SubCategories.Power,
    icon: powerIcon,
    text: "MY_RESILIENCE_SCORE_2",
    navigateTo: "/goals",
    disabled: true,
    state: {},
  },
  {
    value: SubCategories.Reports,
    icon: reportsIcon,
    text: "MY_PROGRESS_REPORTS_2",
    navigateTo: "/goals",
    disabled: true,
    state: {},
  },
];

export const homePageContents = [
  {
    value: "treatment",
    title: "TREATMENT_MENU_2",
    sections: treatmentSections,
  },
  {
    value: "help",
    title: "WE_ARE_HERE_FOR_YOU_2",
    sections: helpSections,
  },
  {
    value: "goals",
    title: "MY_PROGRESS_MENU_2",
    sections: goalsSections,
  },
  {
    value: "profile",
    title: "PROFILE_MENU_2",
    sections: profileSections,
  },
];
